/**
 * AppICEMAP — EmptyState
 * Placeholder shown when there are no results.
 *
 * Usage:
 *   <empty-state icon="map-pin" title="No hay reportes" message="Intenta mover el mapa"></empty-state>
 */

export class EmptyState extends HTMLElement {
	constructor() {
		super();
	}

	connectedCallback() {
		this._render();
	}

	static get observedAttributes() {
		return ["icon", "title", "message"];
	}

	attributeChangedCallback() {
		if (this.isConnected) this._render();
	}

	_render() {
		const icon = this.getAttribute("icon") || "map-pin";
		const title =
			this.getAttribute("title") || "No hay reportes activos en esta zona";
		const message = this.getAttribute("message") || "";

		this.className = "empty-state";
		this.setAttribute("role", "status");

		// Clear previous
		while (this.firstChild) this.firstChild.remove();

		// Icon
		const iconEl = document.createElement("i");
		iconEl.className = `ph ph-${icon} empty-state__icon`;
		iconEl.setAttribute("aria-hidden", "true");
		this.appendChild(iconEl);

		// Title
		const titleEl = document.createElement("h4");
		titleEl.className = "empty-state__title";
		titleEl.textContent = title;
		this.appendChild(titleEl);

		// Message (optional)
		if (message) {
			const msgEl = document.createElement("p");
			msgEl.className = "empty-state__message";
			msgEl.textContent = message;
			this.appendChild(msgEl);
		}
	}
}

customElements.define("empty-state", EmptyState);
